/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * 你想要查询的热榜平台。支持多种主流平台类型，详见下方[可选值](#可选值)表格。
 */
export const GetMiscHotboardType = {
  Bilibili: "bilibili",
  Acfun: "acfun",
  Weibo: "weibo",
  Zhihu: "zhihu",
  ZhihuDaily: "zhihu-daily",
  Douyin: "douyin",
  Kuaishou: "kuaishou",
  DoubanMovie: "douban-movie",
  DoubanGroup: "douban-group",
  Tieba: "tieba",
  Hupu: "hupu",
  Ngabbs: "ngabbs",
  V2ex: "v2ex",
  FiftyTwopojie: "52pojie",
  Hostloc: "hostloc",
  Coolapk: "coolapk",
  Baidu: "baidu",
  Thepaper: "thepaper",
  Toutiao: "toutiao",
  QqNews: "qq-news",
  Sina: "sina",
  SinaNews: "sina-news",
  NeteaseNews: "netease-news",
  Huxiu: "huxiu",
  Ifanr: "ifanr",
  Sspai: "sspai",
  Ithome: "ithome",
  IthomeXijiayi: "ithome-xijiayi",
  Juejin: "juejin",
  Jianshu: "jianshu",
  Guokr: "guokr",
  ThirtySixkr: "36kr",
  FiftyOnecto: "51cto",
  Csdn: "csdn",
  Nodeseek: "nodeseek",
  Hellogithub: "hellogithub",
  Lol: "lol",
  Genshin: "genshin",
  Honkai: "honkai",
  Starrail: "starrail",
  NeteaseMusic: "netease-music",
  QqMusic: "qq-music",
  Weread: "weread",
  Weatheralarm: "weatheralarm",
  Earthquake: "earthquake",
  History: "history",
} as const;
/**
 * 你想要查询的热榜平台。支持多种主流平台类型，详见下方[可选值](#可选值)表格。
 */
export type GetMiscHotboardType = ClosedEnum<typeof GetMiscHotboardType>;

export const GetMiscHotboardType$zodSchema = z.enum([
  "bilibili",
  "acfun",
  "weibo",
  "zhihu",
  "zhihu-daily",
  "douyin",
  "kuaishou",
  "douban-movie",
  "douban-group",
  "tieba",
  "hupu",
  "ngabbs",
  "v2ex",
  "52pojie",
  "hostloc",
  "coolapk",
  "baidu",
  "thepaper",
  "toutiao",
  "qq-news",
  "sina",
  "sina-news",
  "netease-news",
  "huxiu",
  "ifanr",
  "sspai",
  "ithome",
  "ithome-xijiayi",
  "juejin",
  "jianshu",
  "guokr",
  "36kr",
  "51cto",
  "csdn",
  "nodeseek",
  "hellogithub",
  "lol",
  "genshin",
  "honkai",
  "starrail",
  "netease-music",
  "qq-music",
  "weread",
  "weatheralarm",
  "earthquake",
  "history",
]).describe(
  "你想要查询的热榜平台。支持多种主流平台类型，详见下方[可选值](#可选值)表格。",
);

export type GetMiscHotboardRequest = {
  type: GetMiscHotboardType;
  time?: number | undefined;
  keyword?: string | undefined;
  time_start?: number | undefined;
  time_end?: number | undefined;
  limit?: number | undefined;
  sources?: boolean | undefined;
};

export const GetMiscHotboardRequest$zodSchema: z.ZodType<
  GetMiscHotboardRequest
> = z.object({
  keyword: z.string().describe(
    "搜索模式：搜索关键词，在历史热榜中搜索包含该关键词的条目。需配合 time_start 和 time_end 使用。",
  ).optional(),
  limit: z.int().default(50).describe(
    "搜索模式下最大返回条数，默认 50，最大 200。",
  ),
  sources: z.boolean().describe(
    "设为 true 时列出所有可用的历史数据源，忽略其他参数。",
  ).optional(),
  time: z.int().describe(
    "时光机模式：毫秒时间戳，返回最接近该时间的热榜快照。不传则返回当前实时热榜。",
  ).optional(),
  time_end: z.int().describe("搜索模式必填：搜索结束时间戳（毫秒）。")
    .optional(),
  time_start: z.int().describe("搜索模式必填：搜索起始时间戳（毫秒）。")
    .optional(),
  type: GetMiscHotboardType$zodSchema,
});

export type GetMiscHotboardBadGatewayDetails = {};

export const GetMiscHotboardBadGatewayDetails$zodSchema: z.ZodType<
  GetMiscHotboardBadGatewayDetails
> = z.object({});

/**
 * 上游服务错误。我们从目标平台（如微博）获取数据时失败，可能是对方接口暂时不可用或有反爬策略。
 */
export type GetMiscHotboardBadGatewayResponseBody = {
  code?: string | undefined;
  details?: GetMiscHotboardBadGatewayDetails | undefined;
  message?: string | undefined;
};

export const GetMiscHotboardBadGatewayResponseBody$zodSchema: z.ZodType<
  GetMiscHotboardBadGatewayResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetMiscHotboardBadGatewayDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe(
  "上游服务错误。我们从目标平台（如微博）获取数据时失败，可能是对方接口暂时不可用或有反爬策略。",
);

export type GetMiscHotboardInternalServerErrorDetails = {};

export const GetMiscHotboardInternalServerErrorDetails$zodSchema: z.ZodType<
  GetMiscHotboardInternalServerErrorDetails
> = z.object({});

/**
 * 获取热榜失败。服务器在处理数据时发生内部错误。
 */
export type GetMiscHotboardInternalServerErrorResponseBody = {
  code?: string | undefined;
  details?: GetMiscHotboardInternalServerErrorDetails | undefined;
  message?: string | undefined;
};

export const GetMiscHotboardInternalServerErrorResponseBody$zodSchema:
  z.ZodType<GetMiscHotboardInternalServerErrorResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() => GetMiscHotboardInternalServerErrorDetails$zodSchema)
      .optional(),
    message: z.string().optional(),
  }).describe("获取热榜失败。服务器在处理数据时发生内部错误。");

export type GetMiscHotboardBadRequestDetails = {};

export const GetMiscHotboardBadRequestDetails$zodSchema: z.ZodType<
  GetMiscHotboardBadRequestDetails
> = z.object({});

/**
 * 请求参数错误。你提供的 `type` 参数不是我们支持的平台类型，请检查拼写。
 */
export type GetMiscHotboardBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetMiscHotboardBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetMiscHotboardBadRequestResponseBody$zodSchema: z.ZodType<
  GetMiscHotboardBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetMiscHotboardBadRequestDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe(
  "请求参数错误。你提供的 `type` 参数不是我们支持的平台类型，请检查拼写。",
);

export type List = {
  extra?: { [k: string]: any } | undefined;
  hot_value?: string | undefined;
  index?: number | undefined;
  title?: string | undefined;
  url?: string | undefined;
  cover?: string | undefined;
};

export const List$zodSchema: z.ZodType<List> = z.object({
  cover: z.string().optional(),
  extra: z.record(z.string(), z.any()).optional(),
  hot_value: z.string().optional(),
  index: z.int().optional(),
  title: z.string().optional(),
  url: z.string().optional(),
});

export type GetMiscHotboardResult = {
  title?: string | undefined;
  hot_value?: string | undefined;
  url?: string | undefined;
};

export const GetMiscHotboardResult$zodSchema: z.ZodType<GetMiscHotboardResult> =
  z.object({
    hot_value: z.string().optional(),
    title: z.string().optional(),
    url: z.string().optional(),
  });

/**
 * 查询成功！返回指定平台的热榜列表数据。不同模式返回格式不同：默认模式和时光机模式返回 list 数组；搜索模式返回 results 数组；数据源列表模式返回 sources 数组。
 */
export type GetMiscHotboardResponseBody = {
  list?: Array<List> | undefined;
  type?: string | undefined;
  update_time?: string | undefined;
  snapshot_time?: number | undefined;
  keyword?: string | undefined;
  count?: number | undefined;
  results?: Array<GetMiscHotboardResult> | undefined;
  sources?: Array<string> | undefined;
};

export const GetMiscHotboardResponseBody$zodSchema: z.ZodType<
  GetMiscHotboardResponseBody
> = z.object({
  count: z.int().optional(),
  keyword: z.string().optional(),
  list: z.array(z.lazy(() => List$zodSchema)).optional(),
  results: z.array(z.lazy(() => GetMiscHotboardResult$zodSchema)).optional(),
  snapshot_time: z.int().optional(),
  sources: z.array(z.string()).optional(),
  type: z.string().optional(),
  update_time: z.string().optional(),
}).describe(
  "查询成功！返回指定平台的热榜列表数据。不同模式返回格式不同：默认模式和时光机模式返回 list 数组；搜索模式返回 results 数组；数据源列表模式返回 sources 数组。",
);

export type GetMiscHotboardResponse =
  | GetMiscHotboardResponseBody
  | GetMiscHotboardBadRequestResponseBody
  | GetMiscHotboardInternalServerErrorResponseBody
  | GetMiscHotboardBadGatewayResponseBody;

export const GetMiscHotboardResponse$zodSchema: z.ZodType<
  GetMiscHotboardResponse
> = z.union([
  z.lazy(() => GetMiscHotboardResponseBody$zodSchema),
  z.lazy(() => GetMiscHotboardBadRequestResponseBody$zodSchema),
  z.lazy(() => GetMiscHotboardInternalServerErrorResponseBody$zodSchema),
  z.lazy(() => GetMiscHotboardBadGatewayResponseBody$zodSchema),
]);
